import { createAsyncThunk } from '@reduxjs/toolkit';
import { actions } from 'services/store/newSongs';
import { aiService } from 'services/api';
import { AIGeneratedSong, BaseSong, ISongPeaks } from 'services/api/entities';
import { getWaveformData } from 'services/helpers/song';
import { getSongSuccess } from 'services/store/songs/actions';
import { Song } from '../songs/types';
import { NAMESPACE } from './constants';

export const getTrack = createAsyncThunk<
  void,
  {
    songId: BaseSong['id'];
  }
>(`${NAMESPACE}/getTrack`, async ({ songId }, { dispatch }) => {
  const aiSong: AIGeneratedSong = await aiService.getAIGeneratedSong({
    id: songId,
  });

  const songPeaks: ISongPeaks | null = await getWaveformData(aiSong);
  const song: Song = { ...aiSong, peaks: songPeaks };

  dispatch(getSongSuccess({ song }));
  dispatch(actions.storeSongSuccess({ song }));
});
